export  const SocialData=[
    {
        platform:"Github",
        link:"https://github.com/rakesh468",
        icon:"./picture/github.png",
    },{
        platform:"LinkIn",
        link:"https://www.linkedin.com/in/rakesh-kumar-g-30472921a",
        icon:"./picture/linkedin.png",
    },{
        platform:"Gmail",
        link:"rakeshkumarg2000@gmail.com",
        icon:"./picture/gmail.png"
    }
]

